import { OutputDateRange } from 'src/common/page/PageConfigProvider/types/OutputDateRange';
import { SystemCurrency } from 'src/reducer/systemCurrencySlice';

export enum FilterFieldsKeys {
  CreationTime = 'creationTime',
  LastModifiedTime = 'lastModifiedTime',
  OrderId = 'orderId',
  PfhNo = 'pfhNo',
  ClientName = 'clientName',
  CreditCurrency = 'creditCurrency',
}

export type FilterFields = {
  [FilterFieldsKeys.CreationTime]: OutputDateRange;
  [FilterFieldsKeys.LastModifiedTime]: OutputDateRange;
  [FilterFieldsKeys.OrderId]: string;
  [FilterFieldsKeys.PfhNo]: string;
  [FilterFieldsKeys.ClientName]: string;
  [FilterFieldsKeys.CreditCurrency]: SystemCurrency;
};
